import { CommandRequestType } from "../../authentication/connection/commandRequestType";
import { ICommandParameters } from "../../authentication/connection/iCommandParameters";
import { ICommandResponse } from "../../authentication/connection/iCommandResponse";
import { IRequestCommand } from "../../authentication/connection/iRequestCommand";
import { CountryResponseDTO, ErrorDetails } from "../../authentication/connection/interfaces/apiInterfaces";


export class GetPagesCommand extends IRequestCommand<
  IPagesResponse,
  ErrorDetails,
  IPagesParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'multiregion/country/{countryName}';
  public override setParameters(parameters: IPagesParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{countryName}',
      parameters.country.toString()
    );
  }
}

export interface IPagesParameters extends ICommandParameters {
  country: string;
}

export interface IPagesResponse extends CountryResponseDTO, ICommandResponse {}
